// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__WUObr {
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 38px;
  position: sticky;
  bottom: 0;
  z-index: 100;
}

.Footer_refundPolicy__6NWf5 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 553px;
}

.Footer_title__QcYry {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.04em;
  color: #404040;
  margin: 0;
}

.Footer_contentList__Hp4vi {
  list-style-type: disc;
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
}

.Footer_contentItem__EeYNi {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: -0.04em;
  color: #999999;
}

.Footer_viewPolicy__jm8vi {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: -0.04em;
  color: #404040;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.Footer_viewPolicy__jm8vi:hover {
  text-decoration: underline;
}

.Footer_arrowUpicon__1uvKo {
  width: 8px;
  height: 8px;
}

.Footer_securedInfo__-ckJ5{
  display: none;
}

/* Mobile view */
@media (max-width: 480px) {
  .Footer_footer__WUObr {
    padding: 20px;
    position: relative;
  }

  .Footer_lockIcon__NNIW2 {
  width: 12px;
  height: 12px;
}
.Footer_securedInfo__-ckJ5 {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 7px;
}
.Footer_securedInfoText__3rCyK {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.04em;
  color: #404040;
  margin: 0;
}
}
`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/Footer/index.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;EACA,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;AACA","sourcesContent":[".footer {\n  background: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 38px;\n  position: sticky;\n  bottom: 0;\n  z-index: 100;\n}\n\n.refundPolicy {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  max-width: 553px;\n}\n\n.title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: -0.04em;\n  color: #404040;\n  margin: 0;\n}\n\n.contentList {\n  list-style-type: disc;\n  margin: 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.contentItem {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 14px;\n  letter-spacing: -0.04em;\n  color: #999999;\n}\n\n.viewPolicy {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 14px;\n  letter-spacing: -0.04em;\n  color: #404040;\n  text-decoration: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.viewPolicy:hover {\n  text-decoration: underline;\n}\n\n.arrowUpicon {\n  width: 8px;\n  height: 8px;\n}\n\n.securedInfo{\n  display: none;\n}\n\n/* Mobile view */\n@media (max-width: 480px) {\n  .footer {\n    padding: 20px;\n    position: relative;\n  }\n\n  .lockIcon {\n  width: 12px;\n  height: 12px;\n}\n.securedInfo {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 7px;\n}\n.securedInfoText {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: -0.04em;\n  color: #404040;\n  margin: 0;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__WUObr`,
	"refundPolicy": `Footer_refundPolicy__6NWf5`,
	"title": `Footer_title__QcYry`,
	"contentList": `Footer_contentList__Hp4vi`,
	"contentItem": `Footer_contentItem__EeYNi`,
	"viewPolicy": `Footer_viewPolicy__jm8vi`,
	"arrowUpicon": `Footer_arrowUpicon__1uvKo`,
	"securedInfo": `Footer_securedInfo__-ckJ5`,
	"lockIcon": `Footer_lockIcon__NNIW2`,
	"securedInfoText": `Footer_securedInfoText__3rCyK`
};
export default ___CSS_LOADER_EXPORT___;
